import { createSlice } from "@reduxjs/toolkit";
import { CurriculumRequirementResponseDto } from "../../shared/dtos/curriculum/CurriculumRequirementResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const curriculumRequirementSlice = createSlice({
  name: "curriculumRequirement",
  initialState: getInitialCrudState<CurriculumRequirementResponseDto>(),
  reducers: {
    ...generateCrudReducers<CurriculumRequirementResponseDto>(),
  },
});

export const curriculumRequirementActions = curriculumRequirementSlice.actions;
export default curriculumRequirementSlice.reducer;
